import React, {useState} from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import Helpers from "../../../services/Helpers";
import {canAddCustomMealPlan} from "../magicMealPlanHelpers";

export default function CopyPublicPlan(props) {
  let history = useHistory();
  const {makeUrlLookGood} = Helpers();
  const [working, setWorking] = useState(false);
  const canAddPlan = canAddCustomMealPlan({
    plans: props.mmpStore.state.plans,
    hiddenPlans: props.mmpStore.state.hiddenStarterPlans,
    member: props.member,
  });

  const addButton = working ? (
    <button
      className="btn btn-primary"
      type="button"
      disabled={true}
    >
      <span className="spinner-border spinner-border-sm"/>
      <span className="ms-1">Adding...</span>
    </button>
  ) : (
    <button
      className="btn btn-primary"
      type="button"
      onClick={() => {
        setWorking(true);
        props.mmpStore.copyPublicPlan(plan => {
          if (plan.hasOwnProperty("id") && plan.hasOwnProperty("name")) {
            history.push(`/meal-plans/meal-planner/${makeUrlLookGood(plan.id, plan.name)}`);
          } else {
            history.push("/meal-plans/meal-planner");
          }
        });
      }}
    >
      Add to Meal Planner
    </button>
  );

  return (
    <div className="text-sm-center col-12 items-align-middle meal-planner-options my-2">
      {canAddPlan ? addButton : (
        <p>You already have 20 custom plans in your Meal Planner, please delete an existing custom plan to add a new one.</p>
      )}
    </div>
  );
}

CopyPublicPlan.propTypes = {
  mmpStore: PropTypes.object,
  member: PropTypes.object,
}
